import React from 'react';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();
  return (
    <section id="about" className="mb-5 home-about">
        
      <h2 className="heading">About Us</h2>
      {/* <h5>Thematic work area - Education  </h5> */}
      <div>
            <p>
                Janpravaha Social Foundation as the name suggests, it makes an effort to understand the
                needs of the different segments of society & work as facilitator for mainstreaming the
                unacknowledged sector of society.
            </p>
            <p>
                It’s a non-profit organization in Maharashtra working in
                the field of education, development initiatives, infrastructure equipping, health care
                management, skill development & enhancement activities, environment sustenance activities,
                rural development, rehabilitation etc.
                <button type='button' className='btn-read-more' onClick={()=>navigate("/about")}>Read More ...</button>
            </p>

        </div>  
    </section>
  );
};

export default About;
